import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { APP_CONFIG } from '../../config/appConfig';

const Header: React.FC = () => {
  const location = useLocation();
  const linkClass = (path: string) =>
    `text-sm font-medium px-3 py-2 rounded-md transition-colors ${
      location.pathname === path ? 'bg-brand text-white' : 'text-slate-600 hover:bg-slate-100'
    }`;

  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-40">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src="/emerson-logo.png" alt="Emerson" className="w-12 h-12 rounded-lg object-contain" />
          <span className="font-bold text-lg text-slate-800">{APP_CONFIG.TITLE}</span>
        </Link>
        <nav className="flex items-center gap-1">
          <Link to="/" className={linkClass('/')}>Dashboard</Link>
          <Link to="/incidents" className={linkClass('/incidents')}>Incidents</Link>
          <Link to="/admin" className="ml-2 flex items-center gap-1.5 text-sm font-medium px-3 py-2 rounded-md text-brand hover:bg-brand/10">
            <Shield size={16} /> Admin
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
